import { motion } from 'motion/react';
import type { PropsWithChildren } from 'react';
import { pageTransition } from '@/animations/variants';

export function PageTransition({ children }: PropsWithChildren) {
  return (
    <motion.div initial="hidden" animate="visible" exit="exit" variants={pageTransition}>
      {children}
    </motion.div>
  );
}
